/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';

const mock = [
  {
    description: 'Environment Day Celebration',
    href: '/environment-day-celebration-2026',
  },
  {
    description: 'Environment Day Celebration-KG',
    href: '/environment-day-celebration-kg-2026',
  },

   {
    description:
      'Picture Talk(KG)',
    href : '/picture-talk-kg-2026'
 
  },
  {
    description:
      'Picture Talk(MONT)',
    href : '/picture-talk-kg-mont-2026'
 
  },
  {
    description:
      'Onam Celebrations - Pre - Primary ',
    href : '/onam-celebrations-2026'
 
  },
  
  {
    description:
      'Maria Montessori Day Celebration',
    href : '/maria-montessoriday-2026'
  },
  
//   {
//     description:
//       'Dussehra Celebration',
//     href : '/dussehra-celebrations-pre-primary-2025'
 
//   },
//   {
//     description:
//       'WOW-Whispers of Wisdom',
//     href : '/wow-whispers-of-wisdom-2025'
 
//   },
//   {
//     description:
//       'KG Story Telling',
//     href : '/kg-story-telling-2025'
 
//   },
//   {
//     description:
//       'Montessori Story Telling',
//     href : '/mont-story-telling-2025'
 
//   },
//    {
//     description:
//       'Super Heroes Without Capes',
//     href : '/super-heroes-without-capes-2025'
 
//   },
//    {
//     description:
//       'Rainbow of Values',
//     href : '/rainbow-of-values-2025'
 
//   },
//    {
//     description:
//       'Colours Around The World',
//     href : '/colours-around-the-world-2025'
 
//   },
//    {
//     description:
//       'Five Elements Of Nature',
//     href : '/five-elements-of-nature-2025'
 
//   },
//    {
//     description:
//       'Around India in 5 Minutes',
//     href : '/around-india-in-5-minutes-2025'
 
//   },
//    {
//     description:
//       'Extinct & Endangered Animals',
//     href : '/extinct-and-endangered-animals-2025'
//    },
//    {
//     description:
//       'Community Helpers',
//     href : '/community-helpers-2025'
//    },
//    {
//     description:
//       'Joy of Reading',
//     href : '/joy-of-reading-2025'
//    },
//    {
//     description:
//       'Magic of Friendship',
//     href : '/magic-of-friendship-2025'
//    },
//    {
//     description:
//       'Beauty of Nature',
//     href : '/beauty-of-nature-2025'
//    },
//    {
//     description:
//       'Little Star Silver Zone Olympiad',
//     href : '',
//    }
];
const PreprimarySidebar2026 = () => {
  return (
    <Box component={Card} variant="outlined" padding={2}>
      <Typography
        variant="h6"
        data-aos="fade-up"
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Pre Primary 2026-27
      </Typography>

      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display="flex"
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{
                backgroundImage: 'none',
                bgcolor: 'transparent',
              }}
            >
              <Button href={item.href}>
                <Typography component="h6">
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PreprimarySidebar2026;